import React from "react";
import { withTranslation } from "react-i18next";
import { Image, Divider, Button, Spin, Input} from "antd";
import { LeftOutlined } from '@ant-design/icons';
import styled from "styled-components";
import { useState } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";

// Redux
import { resetUiEnv } from 'modules/ui/actions';

// Utils
import { get, post } from "library/endpoints";

// Components
import Text from "components/Text";
import PaydByGiftCard from "../PaydByGiftCard";
import Title from "components/Title";
import PaypalPayment from "components/PaypalPayment";

// styled
import * as Styled from '../../styled';
import { useEffect } from "react";

const StyledButtonLinkGiftCard = styled(Button)`
  color: #53b297;

  &:hover {
    color: #13a9c6 !important;
  }
`;

/**
 * Payment
 * @param {*} props 
 * @returns 
 */
const Payment = (props) => {
  const [displayGiftCard, setDisplayGiftCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [promoCode, setPromoCode] = useState(null)
  const [promoCodeError, setPromoCodeError] = useState(false)
  const [promoCodeData, setPromoCodeData] = useState(null)
  const [paymentError, setPaymentError] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('callback')) {
      if (urlParams.get('callback') === 'stancer') {
        checkStancerPayment(urlParams.get('basket'))
      }
    }

    if (urlParams.get('error')) {
      if (urlParams.get('error') === 'payment_cancelled') {
        setPaymentError(true)
      }
    }
  }, []) // eslint-disable-line

  if (!props.paymentData) {
    props.setView('default');
  }

  const checkStancerPayment = async (basketId) => {
    try {
      setLoading(true)
      const { data } = await get(`/frontend/payment/check-stancer-status/${basketId}`);

      if (data.basket.paid === true) {
        props.resetUiEnv();
        setLoading(false)
        props.push('/orders/success')
      } else if (data.paymentInfos.status !== 'captured' && data.paymentInfos.status !== 'to_capture') {
        props.resetUiEnv();
        setLoading(false)
        props.push('/orders/fail')
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const getPrice = (item) => {
    return item.support.public_price * item.quantity;
  }

  const getTotalPrice = () => {
    let count =  props.paymentData.initial_amount + (props.paymentData.shipping_fees || 0);

    if (promoCodeData) {     
      // Update count with related promo
      props.paymentData.products.forEach((p) => {
        if (promoCodeData.matchingVariants.includes(p.support.variant_id)) {
          let toReduce = 0;
          if (promoCodeData.value_type === 'percent') {
            toReduce = p.support.public_price * (promoCodeData.value / 100)
          } else {
            toReduce = promoCodeData.value;
          }

          count -= toReduce * p.quantity;
        }
      })
    }
    return count;
  }

  const getRemainingPrice = () => {
    return getTotalPrice() - props.paymentData.giftcard_amount;
  }

  const handleOnPayByStripe = async () => {
    try {
      const { data } = await get(`/frontend/payment/${props.paymentData._id}`);
      window.location.href = data.url;
    } catch (error) {
      console.log(error)
    }
  }

  const getCountryName = () => {
    const country = props.countries.find((country) => country._id.toString() === props.paymentData.delivery.country.toString())
    
    if (country) {
      return country
    }

    return {
      name : {
        fr: '',
        en: '',
      }
    }
  }

  const handleOnCheckPromoCode = async () => {
    try {
      const response = await post(`/frontend/promocodes/check`, {
        code: promoCode,
        basket: props.paymentData._id
      })

      if (!response.data) {
        setPromoCodeError(true)
      } else {
        setPromoCodeData(response.data)
        setPromoCodeError(false)
      }
    } catch (error) {
      console.log(error)
      setPromoCodeError(true)
    }
  }

  const checkIfCodeIsApplyable = (entry) => {
    if (promoCodeData) {
      if (promoCodeData.matchingVariants.includes(entry.support.variant_id)) {
        return true;
      }
    }
    return false;
  }

  const applyPromoCodeToPrice = (item, price) => {
    if (promoCodeData) {
      if (promoCodeData.value_type === 'percent') {
        return price * (((100 - promoCodeData.value) / 100))
      } else {
        return price - (promoCodeData.value) * item.quantity;
      }
    }

    return price;
  }

  if (loading) {
    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <Spin />
        </div>
        <Text align="center">Traitement de votre commande en cours, veuillez patienter</Text>
      </div>
    )
  }

  return (
    <>
      <Styled.OptionsSelector
        onClick={() => props.setView('delivery')}      
      >
        <div style={{ width: 30 }}>
          <LeftOutlined style={{ fontSize: 18, cursor: 'pointer', }} />
        </div>
        <Title style={{ marginBottom: 20, marginTop: -2 }} size={18}>Paiement</Title>
      </Styled.OptionsSelector>

      <Text align="center" style={{ marginTop: 20 }} size={14}>Récapitulatif de votre commande</Text>
      
      {
        paymentError && (
          <Text color="red" align="center" size={12} style={{ marginTop: 10 }}>Une erreur s'est produite lors du paiement, veuillez réessayer</Text>
        )
      }

      <Divider />

      {
        props.paymentData && (
          <>
            <div style={{ width: '90%', maxWidth: 500, margin: 'auto', marginTop: 20 }}>
              {
                props.paymentData.products.map((item) => (
                  <>                     
                    <Styled.BasketItem>
                      <Image src={`${process.env.REACT_APP_S3_FILES_URL}${item.mount.output}`} width={50} />

                      <Text size={14} style={{ marginLeft: 10, marginTop: 5 }}>
                        {`${item.support.name_fr || item.support._provider_name} x ${item.quantity}`}
                      </Text>

                      {
                        checkIfCodeIsApplyable(item) ? (
                          <Text size={15} style={{ marginTop: 5, marginLeft: 'auto' }}>
                            <del style={{ marginRight: 10 }}>{getPrice(item).toFixed(2)}€</del>
                            {`${applyPromoCodeToPrice(item, getPrice(item).toFixed(2))}€`}
                          </Text>
                        ) : (
                          <Text size={15} style={{ marginLeft: 'auto', marginTop: 5 }}>{getPrice(item).toFixed(2)}€</Text>
                        )
                      }

                    </Styled.BasketItem>
                    
                    {
                      checkIfCodeIsApplyable(item) && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Text>Code promo appliqué ({`-${promoCodeData.value}${promoCodeData.value_type === 'amount' ? '€' : '%'}`})</Text>
                        </div>
                      )
                    }
                    
                    {
                      item.options.length > 0 && (
                        <div style={{ marginLeft: 10 }}>
                          {
                            item.options.filter((category) => category.selectedOption !== null).length > 0 && (
                              <>
                                <Text size={14} color="grey" style={{ borderBottom: '1px dashed lightgrey', paddingBottom: 5 }}>Options sélectionnées</Text>
                                {
                                  item.options.filter((category) => category.selectedOption !== null).map((category) => (
                                    <div style={{ marginLeft: 10, display: 'flex', paddingTop: 5 }}>
                                      <Text color="grey" size={12}>{`${category.selectedOption.name}`}</Text>

                                      <Text color="grey" style={{ marginLeft: 'auto'}}>
                                        {category.selectedOption.price > 0 ? (
                                          <>{category.selectedOption.price}€</>
                                        ) : 
                                        (
                                          <>Offert</>
                                        )}
                                      </Text>
                                    </div>
                                  ))
                                }
                              </>
                            )
                          }
                        </div>
                      )
                    }
                    
                    <Divider style={{ margin: 10 }} />
                  </>
                ))
              }

              <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
                <Text size={14}>Frais de port</Text>
                <Text size={14} style={{ marginLeft: 'auto' }} >{props.paymentData.shipping_fees || 0}€</Text>
              </div>

              <Divider style={{ margin: 10 }} />

              <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
                <Text size={14} style={{ marginTop: 2 }}>Code promo</Text>
                <div style={{ marginLeft: 'auto', display: 'flex' }}>
                  
                  <Input style={{ width: 100 }} onChange={(e) => setPromoCode(e.target.value.toUpperCase().replaceAll(' ', ''))} value={promoCode} size="small" onKeyDown={(e) => e.key === 'Enter' && handleOnCheckPromoCode()}/>

                  <div style={{ width: 70, marginLeft: 'auto' }}>
                    {
                      promoCode && (
                        <Button size="small" onClick={handleOnCheckPromoCode} type="link" style={{ marginLeft: 10, marginTop: 1, cursor: 'pointer', color: "#53b297" }}>Vérifier</Button>
                      )
                    }
                  </div>
                </div>
              </div>

              {
                promoCodeError && (
                  <Text color="red">Code promo non valide</Text>
                )
              }

              <Divider style={{ margin: 10 }} />
              
              <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
                <Text size={16}>Montant total TTC</Text>
                <Text size={16} style={{ marginLeft: 'auto' }} color="#176b87" >{getTotalPrice().toFixed(2)}€</Text>
              </div>
              
              {
                props.paymentData.giftcard_amount && props.paymentData.giftcard_amount > 0 && (
                  <>
                    <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
                      <Text size={16}>Payé par carte cadeau : </Text>
                      <Text size={16} style={{ marginLeft: 'auto' }} color="#53b6ba" >{props.paymentData.giftcard_amount}€</Text>
                    </div>

                    <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
                      <Text size={16}>Restant dû : </Text>
                      <Text size={16} style={{ marginLeft: 'auto' }} color="#53b6ba" >{getRemainingPrice().toFixed(2)}€</Text>
                    </div>
                  </>
                )
              }

              <Divider style={{ margin: 10 }} />

              <div style={{ marginBottom: 20, marginTop: 20 }}>
                <Text size={16} style={{ marginBottom: 10 }}>Adresse de livraison</Text>
                <Text size={14} style={{ marginBottom: 5 }}>{props.paymentData.delivery.firstname} {props.paymentData.delivery.lastname}</Text>
                <Text size={14} style={{ marginBottom: 5 }}>{props.paymentData.delivery.company}</Text>               
                <Text size={14} style={{ marginBottom: 5 }}>{props.paymentData.delivery.address}</Text> 
                <Text size={14} style={{ marginBottom: 5 }}>{props.paymentData.delivery.postcode} {props.paymentData.delivery.city} {getCountryName().name.fr}</Text>
              </div>
              <Divider style={{ margin: 10 }} />

              <Button style={{ width: '100%', marginBottom: 10 }} onClick={handleOnPayByStripe} type="primary">Payer par carte bancaire</Button>

              {
                (props.ui.theme.paypalClientId && props.ui.theme.paypalClientId !== 'none') && (
                  <>
                    <Divider>ou profitez du paiement en 4x</Divider>
                    <PaypalPayment 
                      basket={props.paymentData}
                      promoCodeData={promoCodeData}
                      promoCode={promoCode}
                    />
                  </>
                )
              }

              {/* {
                props.ui.theme.custom_payment_message && (
                  <iframe title="about-payment" src={props.ui.theme.custom_payment_message} style={{ width: '100%', height: 200, border: 'none', marginTop: 20 }}></iframe>
                )
              } */}

              {
                !props.paymentData.giftcard_amount && (
                  <StyledButtonLinkGiftCard type="link" onClick={() => setDisplayGiftCard(true)}>J'ai une carte cadeau</StyledButtonLinkGiftCard>
                )
              }

              {
                !props.paymentData.giftcard_amount && displayGiftCard && (
                  <PaydByGiftCard
                    basket={props.paymentData}
                    handleRefreshPaymentData={props.setPaymentData}
                    setDisplayGiftCard={setDisplayGiftCard} 
                    totalPrice={getTotalPrice()}
                    setPaymentData={props.setPaymentData}
                    promoCodeData={promoCodeData}
                    promoCode={promoCode}
                  />
                )
              }
            </div>
          </>
        )
      }
    </>
  )
}

const stateToProps = state => ({
  ui: state.ui,
})

const dispatchToProps = {
  push,
  resetUiEnv
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Payment));
